import {
  BookkeeperCompanyIncidenceOptionFragment,
  BookkeepersCompanyIncidenceOptionsDocument,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

interface CompanyIncidenceSettings {
  loading: boolean
  companyIncidenceSettings: BookkeeperCompanyIncidenceOptionFragment[]
}

export const useCompanyIncidenceSettings = (
  companyId: string,
  isBookkeeperView: boolean
): CompanyIncidenceSettings => {
  const { data: incidenceOptionsData, loading: loading } = useQuery(
    BookkeepersCompanyIncidenceOptionsDocument,
    {
      context: {
        isBookkeeperView: isBookkeeperView,
      },
      variables: {
        companyId: companyId,
      },
    }
  )
  const incidenceOptions =
    incidenceOptionsData?.bookkeepersManagement.incidenceOptionsConnection.nodes ?? []
  const companyIncidenceSettings = incidenceOptions.filter((model) => {
    return model.companyId === companyId || model.companyId === null
  })

  return {
    loading,
    companyIncidenceSettings,
  }
}
